const getBrowser = () =>
  [
    () => {
      const match = navigator.userAgent.match(/Opera|OPR/);
      return match && { name: 'Opera', version: 0 };
    },
    () => {
      const brand = navigator.userAgentData?.brands?.find((b) => b.brand.match(/Edg\/(\d+)\./));
      return brand && { name: 'Edge', version: brand.version };
    },
    () => {
      // NOTE: Need to test for Edge before we test for Chrome.
      const match = navigator.userAgent.match(/Edg\/(\d+)\./);
      return match && { name: 'Edge', version: +match[1] };
    },
    () => {
      const brand = navigator.userAgentData?.brands?.find((b) => b.brand.match(/Chrom(e|ium)\/(\d+)\./));
      return brand && { name: 'Chrome', version: brand.version };
    },
    () => {
      const match = navigator.userAgent.match(/Chrom(e|ium)\/(\d+)\./);
      return match && { name: 'Chrome', version: +match[2] };
    },
    () => ({ name: 'Unknown', version: 0 }),
  ]
    .map((fn) => fn())
    .filter(Boolean)
    .shift();

// Studio uses this in SL code. This can be deleted when SL bootstrapper is gone.
window.getBrowser = getBrowser;

export default getBrowser;
